import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './CollabLinks.css';
import '../../css/shared_styles.css';
import blink from '../../images/blink.png'
import emergent from '../../images/emergent.png'
import manus from '../../images/manus.png'
import genspark from '../../images/genspark.png'

const CollabLinks = () => {
  const links = [
     {image : manus, title: 'MANUS AI', url: 'https://manus.im/redeem?c=ALPD6K2M' },
     { image: genspark, title: 'GENSPARK', url: 'https://bit.ly/47Kba4G' } ,
     { image: blink, title: 'BLINK', url: 'https://blink.new/' } ,
    { image: emergent, title: 'EMERGENT', url: 'https://app.emergent.sh/?via=r2d2tech' } ,
   ];

  return (
    <Container id='colaboraciones' className='satoshi-medium main-container'>
      <h2 className='text-center' style={{ marginBottom: '30px' }}>Colaboraciones</h2>
      {links.map((link, index) => (
        <Row key={index} style={{marginBottom:'20px'}}>
          <Col xs={4} className="text-center" style={{marginTop:'20px'}}>
            <img src={link.image} alt={link.title} className="small-round-image" />
          </Col>
          <Col xs={4} className="text-center" style={{marginTop:'10px'}}>
              <p>{link.title}</p>
          </Col>
          <Col xs={4} className="text-center ">
            <Button className='button-generic' variant="primary" href={link.url} target="_blank" style={{marginTop:'10px'}}>Ver más</Button>
          </Col>
        </Row>
      ))}
    </Container>
  );
}

export default CollabLinks;
